export const PRODUCTION = process.env.NODE_ENV === 'production';

export const ROUTES = {
  ABOUT: '/',
  // TODO: make sure profile page is unneeded
  // PROFILE: '/profile',
  MY_TRIPS: '/my-trips',
  CREATE_TRIP: '/create-trip',
  COMMUNITY: '/community',
};

export const API_URL = PRODUCTION ? 'https://project-team-xing.onrender.com' : 'http://localhost:4399';
export const PYTHON_API_URL = PRODUCTION ? 'https://xing-python-backend.onrender.com' : 'https://xing-python-backend.nyoeghau.com';

export const ACTION_TYPES = Object.freeze({
  SET_AI_KEY: Symbol('SET_AI_KEY'),
  SET_MAP_KEY: Symbol('SET_MAP_KEY'),
  SET_WEATHER_KEY: Symbol('SET_WEATHER_KEY'),
  SET_CURR_COORDS: Symbol('SET_CURR_COORDS'),
  SET_CURR_WEATHER: Symbol('SET_CURR_WEATHER'),
});
